// extracted by mini-css-extract-plugin
export var social_link_container = "img-link-module--social_link_container--UD6jE";